import * as React from "react";
import { MessageCard, MessageCardSeverity } from "azure-devops-ui/MessageCard";
import { IButtonProps } from "azure-devops-ui/Button";

export default class WarningExample extends React.Component {
    private buttonProps: IButtonProps[] = [
        {
            text: "Open docs",
            onClick: () => {
                alert("Docs will be opened");
            }
        },
        {
            text: "Manage services",
            onClick: () => {
                alert("Services will be managed");
            }
        }
    ];

    public render(): JSX.Element {
        const message: string = "This pipeline needs to some extra configuration.";

        return (
            <MessageCard
                buttonProps={this.buttonProps}
                className="flex-self-stretch"
                onDismiss={this.onDismiss}
                severity={MessageCardSeverity.Warning}
            >
                {message}
            </MessageCard>
        );
    }

    private onDismiss = () => {
        alert("Parents should use onDismiss to stop rendering the Message Bar");
    };
}
